import { Box } from '@wix/design-system';
import { DealerApiClient } from '@wix/package-picker-sdk';
import { getSearchParams } from '@wix/package-picker-shared';
import { TrustBuilder } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import AcceptPaymentMethods from '../../assets/icons/accept-payment-methods.svg';
import MoneyBack from '../../assets/icons/money-back.svg';
import SecurePayment from '../../assets/icons/secure-payment.svg';
import { eclipseServerData } from '../../utils';
export const TrustBuilders = () => {
  var _paymentMethodsQuery$;
  const {
    siteGuid
  } = getSearchParams();
  const shouldFetch = !!siteGuid;
  const {
    siteAuthorizationType
  } = eclipseServerData.get();
  const paymentMethodsQuery = DealerApiClient.hooks.useGetAcceptedPaymentMethods({
    siteId: siteGuid,
    siteAuthorizationType
  }, shouldFetch);
  const paymentMethods = (_paymentMethodsQuery$ = paymentMethodsQuery.data) == null ? void 0 : _paymentMethodsQuery$.paymentMethods;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3",
    align: "center",
    maxWidth: "100%"
  }, /*#__PURE__*/React.createElement(TrustBuilder.Root, null, /*#__PURE__*/React.createElement(TrustBuilder.Item.PaymentMethods, {
    icon: /*#__PURE__*/React.createElement(AcceptPaymentMethods, null),
    direction: "vertical",
    align: "center",
    paymentMethodsOverride: paymentMethods
  }), /*#__PURE__*/React.createElement(TrustBuilder.Item.MoneyBack, {
    icon: /*#__PURE__*/React.createElement(MoneyBack, null),
    direction: "vertical",
    align: "center"
  }), /*#__PURE__*/React.createElement(TrustBuilder.Item.Ssl, {
    icon: /*#__PURE__*/React.createElement(SecurePayment, null),
    direction: "vertical",
    align: "center"
  })));
};
//# sourceMappingURL=TrustBuilders.js.map